import { render, staticRenderFns } from "./ScheduleExpirationBadge.vue?vue&type=template&id=77f0287e&scoped=true"
import script from "./ScheduleExpirationBadge.vue?vue&type=script&lang=ts"
export * from "./ScheduleExpirationBadge.vue?vue&type=script&lang=ts"
import style0 from "./ScheduleExpirationBadge.vue?vue&type=style&index=0&id=77f0287e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0287e",
  null
  
)

export default component.exports